import React from "react";
import Background from '../images/dark.jpg';
import '../styles/cover.css';

export default function Cover() {
    return (
        <div className="outer-container-cover">
            <div className="container-my-cover">
                <img src={Background} className="responsive-cover"/>
                <div className="content-cover font-weight-light">
                    <p className="cover-heading">SIDDHARTH S. DWIVEDI & CO.</p>
                    <span className="cover-heading2"> Chartered Accountants </span>
                    <p className="cover-subheading">Where Money meets Savings</p>
                </div>
            </div>
        </div>
    )
}